import LibertyMorality from './LibertyMorality.jpg';

function LibertyMoralityEmbed(){
    return (
        <>
        <img src={LibertyMorality} alt="Liberty and Morality Statues - National Monument to the Forefathers" className="faithImage" />
        </>
    );
};
export default LibertyMoralityEmbed;